/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Candenycontacts2Inputs */

const en_entity_candenycontacts2 = /** @type {(inputs: Entity_Candenycontacts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can Deny Contacts`)
};

const de_entity_candenycontacts2 = /** @type {(inputs: Entity_Candenycontacts2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann Kontakte ablehnen`)
};

/**
* | output |
* | --- |
* | "Can Deny Contacts" |
*
* @param {Entity_Candenycontacts2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_candenycontacts2 = /** @type {((inputs?: Entity_Candenycontacts2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Candenycontacts2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_candenycontacts2(inputs)
	return de_entity_candenycontacts2(inputs)
});
export { entity_candenycontacts2 as "entity_canDenyContacts" }